import React from "react";
import AppRoutes from "../AppRoutes";
import NavBar from "./Navigation/NavBar";
import {SystemError} from "./Error/SystemError";
import GlobalMenu from "./Navigation/GlobalMenu";

export default function Layout() {
    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <NavBar />
            <div style={{display: "flex", flexDirection: "row"}}>
                <GlobalMenu/>
                <AppRoutes />
            </div>
            <SystemError />
        </div>
    );
}

